<template>
    <el-dialog title="日志" :visible.sync="popRef" width="60%" @open="onDialogOpen">
      <el-table
        ref="multipleTable"
        :data="dt.data"
        :stripe="true"
        border
        highlight-current-row
        style="width: 100%"
        :size="dt.size"
        @sort-change="dt.handleSortChange">
        <el-table-column property="createdAt" label="时间" min-width=15% :formatter="dateFormat" sortable="custom" />
        <el-table-column property="modifyUser.staffName" label="操作人" min-width=15% sortable="custom" />
        <el-table-column property="action" label="操作" min-width=30% sortable="custom" />
      </el-table>
      <el-pagination
        @size-change="dt.handleSizeChange"
        @current-change="dt.handleCurrentChange"
        :current-page="dt.currentPage"
        :page-sizes="dt.pageSizes"
        :page-size="dt.pageSize"
        :layout="dt.layout"
        :total="dt.totalElements">
      </el-pagination>
    </el-dialog>
</template>

<script>
  import {DataTable} from "../../../data-table";

  export default {
    name: "CommonLogListDialog",
    data: function () {
      return {
        dt: DataTable.getInstance(this, '/admin/CommonLog/findPage', null, null, {className: this.objClassNameRef, refObjId: this.objIdRef}),
        // 双向绑定额要求额外增加的引用字段
        popRef: this.pop,
        objIdRef: this.objId,
        objClassNameRef: this.objClassName
      }
    },
    props: {
      objId: null,
      objClassName: null,
      pop: false // 是否显示弹出框
    },
    watch: {
      pop (v) {
        this.popRef = v; // 监听外部变化同步到 popRef 上
      },
      objId (v) {
        this.objIdRef = v;
      },
      objClassName (v) {
        this.objClassNameRef = v;
      },
      popRef (v) {
        this.$emit("onPopChange", v); // 组件内对popRef变更后向外部发送事件
      }
    },
    mounted: function () {
    },
    methods: {
      //  日期格式化
      dateFormat: function (row, column) {
        var date = row[column.property];
        if (date === undefined || date === null) {
          return "";
        }
        return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
      },
      // 布尔值格式化
      booleanFormat: function (row, column) {
        var data = row[column.property];
        if (data === undefined || data === null) {
          return "";
        }
        return data ? "是" : "否";
      },
      onDialogOpen: function () {
        this.dt.extnedsParms = {className: this.objClassNameRef, refObjId: this.objIdRef};
        this.dt.page = 0;
        this.dt.queryPageData();
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CommonLogListDialog.vue?4cb707bc